<template>
  <v-dialog
    v-model="showDialog"
    max-width="75%"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mx-2"
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
        fab
        small
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <slot>
              <v-icon
                v-bind="attrs"
                v-on="on"
                dark
              >
                mdi-plus
              </v-icon>
            </slot>
          </template>
          add new audio to {{ playlistType }}
        </v-tooltip>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Upload audio to {{ playlistType }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-file-input
                v-model="file"
                :loading="loading"
                :disabled="disabled"
                accept=".mp3, .wav"
                label="Click here to upload audio"
              />
            </v-col>
          </v-row>
          <v-row v-if="playlistId===null && !!listItems.length">
            <v-col>
              <v-autocomplete
                v-model="dialogListIds"
                :items="listItems"
                :filter="nonDiacriticsSensitiveFilter"
                auto-select-first
                item-text="name"
                item-value="id"
                hide-selected
                multiple
                chips
                deletable-chips
                :label="playlistType"
                :menu-props="{
                          closeOnContentClick: true,
                        }"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="isDisabledAddButton"
          :loading="loading"
          color="blue darken-1"
          text
          @click="addAudio(false)"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'AudioDialogAdd',
  props: {
    listItems: {
      type: Array,
      default() {
        return [];
      },
    },
    playlistType: {
      type: String,
      default: '',
    },
    playlistId: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
    },
  },
  data: () => ({
    dialogListIds: [],
    showDialog: false,
    file: null,
    loading: false,
    disabled: false,
    geotagId: null,
  }),
  methods: {
    cancel() {
      this.dialogListIds = [];
      this.showDialog = false;
      this.loading = false;
      this.file = null;
      this.disabled = false;
    },
    addAudio() {
      if (!this.file || (this.playlistId === null && !this.dialogListIds.length)) {
        return;
      }

      this.loading = true;
      this.disabled = true;

      const data = new FormData();
      const requestedListId = this.playlistId === null
        ? this.dialogListIds
        : this.playlistId;
      data.append('audio_file', this.file);
      data.append('audiable_id', requestedListId);
      data.append('audiable_type', this.playlistType);

      this.$requestHelpers
        .post('api/admin/audio',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
        .then(() => {
          this.$emit('addNew', true);
        }).catch(() => {
          this.$emit('addNew', false);
        })
        .finally(() => {
          this.dialogListIds = [];
          this.showDialog = false;
          this.loading = false;
          this.file = null;
          this.disabled = false;
        });
    },
  },

  computed: {
    isDisabledAddButton() {
      return !this.file || (this.playlistId === null && !this.dialogListIds.length);
    },
  },
};
</script>
